export default __webpack_public_path__ + "static/smartphone-con-fogli-45f6117d3b334208ec6cc222e466b04e.svg";